// extracted by mini-css-extract-plugin
export default {"container":"RegistrationContainer_container__CNUzT"};